module.exports = __webpack_public_path__ + "img/营业.df23f0e9.png";